module.exports = __webpack_public_path__ + "img/img22.56494754.png";